/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".custom-datepicker-header[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;padding:1em 1.5rem 2rem}.custom-datepicker-label[_ngcontent-%COMP%]{-webkit-box-flex:1;flex:1;font-weight:500;text-align:center}.arrow[_ngcontent-%COMP%]{cursor:pointer}"];
export { styles as styles };
